export const langText = {
  en: { Wind: 'Wind', Humidity: 'Humidity', FeelsLike: 'Feels like' },
  pl: { Wind: 'Wiatr', Humidity: 'Wilgotność', FeelsLike: 'Odczuwalna' },
  de: { Wind: 'Wind', Humidity: 'Feuchtigkeit', FeelsLike: 'Gefühlt' },
  es: { Wind: 'Viento', Humidity: 'Humedad', FeelsLike: 'Sensación' },
  ru: { Wind: 'Ветер', Humidity: 'Влажность', FeelsLike: 'Ощущается как' },
};
